import React from "react";

// Animated "I" monogram for IMPERIUM — BMW-M / aurora gradient shimmer with subtle ECU traces.
export const BrandLogo = ({ className = "w-6 h-6" }) => {
  const gid = "imperiumGrad";
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Imperium">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="36" y2="48" gradientUnits="userSpaceOnUse" spreadMethod="reflect">
          <stop offset="0" stopColor="#0064B0" />
          <stop offset="0.33" stopColor="#5E3DA8" />
          <stop offset="0.62" stopColor="#C8102E" />
          <stop offset="1" stopColor="#00E5FF" />
          <animateTransform attributeName="gradientTransform" type="translate" from="-24 0" to="24 0" dur="4.5s" repeatCount="indefinite" />
        </linearGradient>
      </defs>

      {/* ECU traces */}
      <g stroke="#00E5FF" strokeWidth="1.4" opacity="0.55" strokeLinecap="round">
        <path d="M6 24 H12" />
        <path d="M42 24 H36" />
        <circle cx="5" cy="24" r="1.4" fill="#00E5FF" stroke="none" />
        <circle cx="43" cy="24" r="1.4" fill="#00E5FF" stroke="none" />
      </g>

      {/* Serif "I" monogram */}
      <g fill={`url(#${gid})`}>
        <rect x="11" y="8" width="26" height="6.5" rx="2" />
        <rect x="19.25" y="8" width="9.5" height="32" rx="2" />
        <rect x="11" y="33.5" width="26" height="6.5" rx="2" />
      </g>
    </svg>
  );
};
